import { createContext, useState, useEffect, SyntheticEvent, useMemo } from 'react';
import jwtDecode from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'material-react-toastify';
import secureLocalStorage from 'react-secure-storage';

const AuthContext = createContext();

export default AuthContext;

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(() =>
    localStorage.getItem('access') ? localStorage.getItem('access') : null
  );
  const [user, setUser] = useState(() =>
    localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
  );

  const saveUser = (values) => {
    setUser(values);
  };
  const notifyErrorLogin = (messageError) => {
    toast.error(messageError, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };

  const navigate = useNavigate();

  const logoutUser = () => {
    const access = localStorage.getItem('access');
    const refresh = localStorage.getItem('refresh');
    const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
    axios({
      method: 'post',
      url: `${API_ENDPOINT}/api/logout/`,
      headers: { Authorization: `Bearer ${access}` },
      data: { refresh_token: `${refresh}` }
    })
      .then((res) => {
        setToken(null);
        setUser(null);
        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
        localStorage.removeItem('user');
        navigate('/login');
      })
      .catch((err) => {
        if (err.response.status >= 500) {
          notifyErrorLogin('Network Error');
          console.log('status', err.response.status);
        } else {
          notifyErrorLogin(err.message);
        }
      });
  };

  const contextData = {
    user,
    setUser,
    logoutUser,
    saveUser
  };
  return <AuthContext.Provider value={contextData}>{children}</AuthContext.Provider>;
};
